<template>
  <div class="viewcontent">
    <Activities :event="event" :type="'next'" :key="event.id" />
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import Activities from '@/components/Activities.vue'

  export default {
    name: 'Event_edit',
    components: {
      Activities,
    },

    computed: {
      ...mapState(['event']),
    },
    methods: {
      ...mapActions(['getEvent']),
    },
    async created() {
      await this.getEvent({ id: this.$route.params.id, type: 'get' })
    },
    watch: {
      $route(to, from) {
        if (to == 'Event_edit') {
          this.getEvent({ id: this.$route.params.id, type: 'get' })
        }
      },
    },
  }
</script>

<style scoped></style>
